import React, { useContext, useState, useEffect } from "react";
import CertificationInvoice from "../../views/invoice/components/certification_invoice.jsx";
import InvoiceTab from "../../views/invoice/components/invoice_tab.jsx";
import ProductionInvoice from "../../modules/subscription_module/invoices_module/components/production/productionInvoice.jsx";
import StagingInvoice from "../../modules/subscription_module/invoices_module/components/staging/stagingInvoice.jsx";
import { invoiceCurrentTabContext } from "../../views/invoice/context/invoice_context.jsx";
import TechSupportInvoice from "../../modules/subscription_module/invoices_module/components/tech_support/techSupportInvoice.jsx";

const InvoiceLayout = () => {
  const [load, setLoad] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  

  const [localCurrentTab, setLocalCurrentTab] = useState({ 
    name: "Certification", 
    id: 1, 
    tabKey: "certification" 
  });
  

  const contextValue = useContext(invoiceCurrentTabContext);
  const currentTab = contextValue?.currentTab || localCurrentTab;


  const availableTabs = [
    { name: "Certification", id: 1, tabKey: "certification" },
    { name: "Staging", id: 2, tabKey: "staging" },
    { name: "Production", id: 3, tabKey: "production" },
    { name: "Tech Support", id: 4, tabKey: "tech_support" },
    { name: "Membership", id: 5, tabKey: "membership" }
  ];


  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (contextValue?.currentTab && !isMobile) {
      setLocalCurrentTab(contextValue.currentTab);
    }
  }, [contextValue?.currentTab, isMobile]);


  const handleTabChange = (tab) => {
    setLocalCurrentTab(tab);
    setDropdownOpen(false);

    try {
      if (contextValue?.setCurrentTab && typeof contextValue.setCurrentTab === 'function') {
        contextValue.setCurrentTab(tab);
      }
    } catch (error) {
      console.log("Context update failed, using local state only");
    }
  };

  const getCurrentTabName = () => {
    if (!isMobile && contextValue?.currentTab) {
      return contextValue.currentTab.name || "Certification";
    }
    return localCurrentTab.name || "Certification";
  };

  if (!load) {
    return (
      <div className="w-full bg-gray-100 min-h-screen">
        <div className={`${isMobile ? 'p-4' : 'p-6'}`}>
          {/* Header Section - KEEP ORIGINAL WEB DESIGN */}
          <div className="md:flex md:items-center md:justify-between">
            <h2
              style={{
                marginLeft: isMobile ? "0px" : "8px",
                fontSize: isMobile ? "20px" : "18px",
                marginBottom: isMobile ? "20px" : "25px",
                fontWeight: "bold",
                color: "#2A3042",
                textAlign: isMobile ? "center" : "left"
              }}
            >
              My Invoices
            </h2>
          </div>

          {/* Content Section */}
          <div>
            {/* Menu Tabs Section - Desktop vs Mobile - KEEP ORIGINAL WEB DESIGN */}
            {isMobile ? (
              /* Mobile Dropdown */
              <div className="relative mb-6">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-left shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#374151"
                  }}
                >
                  <div className="flex items-center justify-between">
                    <span>{getCurrentTabName()}</span>
                    <svg
                      className={`w-5 h-5 transition-transform duration-200 ${
                        dropdownOpen ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </button>

                {/* Dropdown Menu */}
                {dropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    {availableTabs.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab)}
                        className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-150 ${
                          getCurrentTabName() === tab.name 
                            ? 'bg-blue-50 text-blue-600 font-medium' 
                            : 'text-gray-700'
                        } ${
                          tab.id === 1 ? 'rounded-t-lg' : ''
                        } ${
                          tab.id === availableTabs.length ? 'rounded-b-lg' : 'border-b border-gray-200'
                        }`}
                        style={{
                          fontSize: "15px"
                        }}
                      >
                        {tab.name}
                      </button>
                    ))}
                  </div>
                )}

                {/* Backdrop to close dropdown */}
                {dropdownOpen && (
                  <div
                    className="fixed inset-0 z-5"
                    onClick={() => setDropdownOpen(false)}
                  ></div>
                )}
              </div>
            ) : (
              /* Desktop Tabs - KEEP ORIGINAL DESIGN */
              <div
                className="flex-1 min-w-0 mobile:pt-4 mobile: ml-2"
                style={{ 
                  marginBottom: "0px",
                  overflowX: "visible"
                }}
              >
                <InvoiceTab />
              </div>
            )}

            {/* Tab Content - FIXED: Now syncs with both mobile and desktop */}
            {getCurrentTabName() === "Staging" && (
              <>
                <div className={`${isMobile ? 'min-h-[60vh] pt-8 pb-6' : 'min-h-screen pt-16 pb-12'} flex flex-col`}>
                  <div className={`${isMobile ? 'py-8' : 'py-16'}`}>
                    <div className="text-center">
                      <h1 
                        className={`mt-2 font-extrabold text-gray-900 tracking-tight ${
                          isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                        }`}
                        style={{
                          fontSize: isMobile ? "24px" : undefined,
                          lineHeight: isMobile ? "1.3" : undefined,
                          padding: isMobile ? "0 20px" : "0"
                        }}
                      >
                        Coming Soon
                      </h1>
                      {isMobile && (
                        <p className="mt-4 text-gray-600 text-sm px-4">
                          Staging invoices will be available soon
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {getCurrentTabName() === "Production" && (
              <>
                <div className={`${isMobile ? 'min-h-[60vh] pt-8 pb-6' : 'min-h-screen pt-16 pb-12'} flex flex-col`}>
                  <div className={`${isMobile ? 'py-8' : 'py-16'}`}>
                    <div className="text-center">
                      <h1 
                        className={`mt-2 font-extrabold text-gray-900 tracking-tight ${
                          isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                        }`}
                        style={{
                          fontSize: isMobile ? "24px" : undefined,
                          lineHeight: isMobile ? "1.3" : undefined,
                          padding: isMobile ? "0 20px" : "0"
                        }}
                      >
                        Coming Soon
                      </h1>
                      {isMobile && (
                        <p className="mt-4 text-gray-600 text-sm px-4">
                          Production invoices will be available soon
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {getCurrentTabName() === "Tech Support" && (
              <>
                <div className={`${isMobile ? 'min-h-[60vh] pt-8 pb-6' : 'min-h-screen pt-16 pb-12'} flex flex-col`}>
                  <div className={`${isMobile ? 'py-8' : 'py-16'}`}>
                    <div className="text-center">
                      <h1 
                        className={`mt-2 font-extrabold text-gray-900 tracking-tight ${
                          isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                        }`}
                        style={{
                          fontSize: isMobile ? "24px" : undefined,
                          lineHeight: isMobile ? "1.3" : undefined,
                          padding: isMobile ? "0 20px" : "0"
                        }}
                      >
                        Coming Soon
                      </h1>
                      {isMobile && (
                        <p className="mt-4 text-gray-600 text-sm px-4">
                          Tech Support invoices will be available soon
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {getCurrentTabName() === "Certification" && (
              <div className={`w-full ${isMobile ? 'mt-2' : ''}`}>
                {/* Mobile-responsive wrapper for CertificationInvoice */}
                <div className={`${
                  isMobile 
                    ? 'bg-white rounded-lg shadow-sm mx-auto max-w-full overflow-x-hidden' 
                    : ''
                }`}>
                  {/* Pass isMobile prop to CertificationInvoice */}
                  <CertificationInvoice isMobile={isMobile} />
                </div>
                
                {/* Add mobile-specific padding/spacing */}
                {isMobile && <div className="h-4"></div>}
              </div>
            )}

            {getCurrentTabName() === "Membership" && (
              <>
                <div className={`${isMobile ? 'min-h-[60vh] pt-8 pb-6' : 'min-h-screen pt-16 pb-12'} flex flex-col`}>
                  <div className={`${isMobile ? 'py-8' : 'py-16'}`}>
                    <div className="text-center">
                      <h1 
                        className={`mt-2 font-extrabold text-gray-900 tracking-tight ${
                          isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                        }`}
                        style={{
                          fontSize: isMobile ? "24px" : undefined,
                          lineHeight: isMobile ? "1.3" : undefined,
                          padding: isMobile ? "0 20px" : "0"
                        }}
                      >
                        Coming Soon
                      </h1>
                      {isMobile && (
                        <p className="mt-4 text-gray-600 text-sm px-4">
                          Membership invoices will be available soon
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-gray-100 min-h-screen">
      <div className="flex items-center justify-center" style={{ minHeight: "50vh" }}>
        <div className="text-center p-8">
          <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${
            isMobile ? 'h-12 w-12' : 'h-16 w-16'
          }`}></div>
          <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
            Loading Invoices
          </h3>
          <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
            Please wait while we fetch your invoice data...
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceLayout;